import { useQuery } from '@tanstack/react-query';

import { usageEnforcementService } from '../services/usage-enforcement.service';

/**
 * Every model a category can hold. Its own cache key: the chat pickers share `['llm-models']`
 * and hold only the models the caller may use, so the two lists must not overwrite each other.
 */
export const useGetLlmModels = () =>
  useQuery({
    queryKey: ['llm-models', 'include-restricted'],
    queryFn: () => usageEnforcementService.getModels(),
  });
